import React, { Component } from 'react';
import '../App.css';
import CalendarAPI from '../Codes/CalendarAPI';

class DropdownCalendarName extends Component {
  constructor(props) {
    super(props);
    
    
    this.state = {
      showMenu: false,
      currentCalendarIndex: undefined, 
      primaryIndex: undefined,
      allCalendars: undefined
    };
    
    this.generateDropdownItems = this.generateDropdownItems.bind(this);
    this.showCloseMenu = this.showCloseMenu.bind(this);
  }

  componentWillMount(){
    CalendarAPI.getCalendarsList(this.updateAllCalendars.bind(this));
  }
  updateAllCalendars(calendars){
    let indexOfP=undefined;
    for(let i=0;i<calendars.length&& indexOfP===undefined;i++){
      if(calendars[i].primary)
        indexOfP=i;
    }
    this.setState({allCalendars: calendars, primaryIndex: indexOfP, currentCalendarIndex: indexOfP});
    this.props.setToCalendar(this.state.allCalendars[indexOfP].id);
  }
  
  showCloseMenu(event) {
    event.preventDefault();
    this.setState({ showMenu: !this.state.showMenu});
  }
  
  chooseCalendar(event){
      //console.log(event.currentTarget.id);
      //console.log(this.state.allCalendars[parseInt(event.target.id.slice(1))]);
    let index=parseInt(event.currentTarget.id.slice(1));
    this.setState({currentCalendarIndex: index, showMenu:false});
    this.props.setToCalendar(this.state.allCalendars[index].id);
    //this.setState({currentCalendar: event.target.value, showMenu:false});
    //this.props.updateCalendar(this.state.allCalendars[parseInt(event.target.id.slice(1))].summary);
  }

  generateDropdownItems(){
    let buttons =[];
    let calendars=this.state.allCalendars;
    for(let i=0;i<calendars.length;i++)
    {
        buttons.push(<button className="flex-row dropdown-item" id={"c"+i} key={calendars[i].summary}
         onClick={this.chooseCalendar.bind(this)}>
         <div id="y" className="inline col-1" style={{color: calendars[i].backgroundColor}}>&#11044;</div>
         <div id="x" className="inline col-11">{calendars[i].summary}</div>
         </button>);
    }
    return buttons;
  }

  render() {
    return (
      <div className="col-12 calendar-name-dropdown-container btn-group dropup">
        
        <button className="btn dropdown-toggle" onClick={this.showCloseMenu}>
          {
            (this.state.currentCalendarIndex!==undefined?
            "  "+this.state.allCalendars[this.state.currentCalendarIndex].summary+"  ":
            "loading")
          }
        </button>
        
        {
          this.state.showMenu
            ? (
              <div>
                <div className="overlay" onClick={this.showCloseMenu}></div>
                <div className="dropdown-menu dropup" >
                  {this.generateDropdownItems()}
                </div>
              </div>
            )
            : (
              null
            )
        }
      </div>

    );
  }
}

export default DropdownCalendarName;


// WEBPACK FOOTER //
// ./src/components/DropdownCalendarName.js